
<template>
  <div>
    <el-dialog class="wp90 hp90" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close style="min-width: 1030;">
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Suitcase />
          </el-icon>
          <span class="header-title">试题库</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container class="hp100">
        <!-- 题库区域 BEGIN -->
        <el-aside width="250px">
          <el-container>
            <el-main class="pl0 pr0">
              <el-tree ref="treeRef" :data="treeData" node-key="id" default-expand-all highlight-current :props="{children: 'children', label: 'zystkmc'}" :filter-node-method="filterNode">
                <template #default="{ data }">
                  <div class="custom-tree-node">
                    <div class="wp100" @click="dataGrid.parms.zystkstkid=data.id;row=data;bindTable()">
                      <span class="ming-cheng" >{{ data.zystkmc }}</span>
                      <span class="shu-liang ml5">({{ data.count }})</span>
                    </div>
                  </div>
                </template>
              </el-tree>
            </el-main>
          </el-container>
        </el-aside>
        <!-- 题库区域 END -->
        <!-- 试题区域 BEGIN -->
        <el-main class="pt0 pr0">
          <el-container class="hp100">
            <el-header class="pl0 pr0">
              <!-- 搜索区域 BEGIN -->
              <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>

                <el-form-item>
                  <el-select placeholder="题型" v-model="dataGrid.parms.txid" clearable filterable @change="bindTable()">
                    <el-option v-for="item in txData" :key="item.id" :label="item.bt" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select placeholder="题类" v-model="dataGrid.parms.tlid" clearable filterable @change="bindTable()">
                    <el-option v-for="item in tlData" :key="item.id" :label="item.bt" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select placeholder="课程" v-model="dataGrid.parms.kcid" clearable filterable @change="bindTable()">
                    <el-option v-for="item in kcData" :key="item.id" :label="item.kcmc" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select placeholder="审核状态" v-model="dataGrid.parms.zystkstshzt" clearable filterable @change="bindTable()">
                    <el-option label="已审核" :value="true" />
                    <el-option label="未审核" :value="false" />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select placeholder="审核结果" v-model="dataGrid.parms.zystkstshjg" clearable filterable @change="bindTable()">
                    <el-option label="已通过" :value="2" />
                    <el-option label="未通过" :value="1" />
                    <el-option label="未审核" :value="0" />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select placeholder="提交状态" v-model="dataGrid.parms.zystkstshtjzt" clearable filterable @change="bindTable()">
                    <el-option label="已提交" :value="true" />
                    <el-option label="未提交" :value="false" />
                  </el-select>
                </el-form-item>
              </el-form>
              <!-- 搜索区域 END -->
              <!-- 按钮区域 BEGIN -->
              <div class="button-box">
                <el-button type="primary" @click="addShiTiClick()"><span class="iconfont icon-chuangjian"></span>添加试题</el-button>
                <el-button type="primary" @click="tiJiaoClick()">批量提交</el-button>
                <!-- <el-dropdown>
                  <el-button class="w200" type="info">
                    <el-icon class="el-icon--left">
                      <DocumentCopy />
                    </el-icon>导入/导出<el-icon class="el-icon--right">
                      <arrow-down />
                    </el-icon>
                  </el-button>
                  <template #dropdown>
                    <el-dropdown-menu class="w200">
                      <el-dropdown-item>
                        <el-upload :http-request="importInsert" :auto-upload="true" :show-file-list="false" accept=".xlsx, .xls">Excel导入数据</el-upload>
                      </el-dropdown-item>
                      <el-dropdown-item @click="exportData" divided>导出到Excel</el-dropdown-item>
                      <el-dropdown-item @click="download">下载Excel模板</el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown> -->
              </div>
              <!-- 按钮区域 END -->
            </el-header>
            <el-main class="pl0 pr0">
              <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
                <!-- 冻结列-Left BEGIN -->
                <el-table-column type="selection" width="55" align="center" />
                <el-table-column label="序号" type="index" width="60" fixed align="center" />
                <el-table-column label="题型" prop="zystksttxmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="课程" prop="kcmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="教学单元" prop="zystkstsyjxdymc" min-width="110" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="教学内容" prop="zystkstsyjxnrmc" min-width="110" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="适用类型" prop="sylxmclist" min-width="110" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="上传时间" prop="zystkstscsj" width="160" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="试题正文" min-width="150" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                  <template #default="scope">
                    <p style="white-space: pre-wrap; text-indent:0;" v-html="scope.row.zystkstzw"></p>
                  </template>
                </el-table-column>
                <el-table-column label="审核状态" width="110" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                  <template #default="scope">
                    <span v-if="scope.row.zystkstshzt === true">已审核</span>
                    <span v-if="scope.row.zystkstshzt === false">未审核</span>
                  </template>
                </el-table-column>
                <el-table-column label="审核结果" width="110" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                  <template #default="scope">
                    <span v-if="scope.row.zystkstshjg === 2">已通过</span>
                    <span v-if="scope.row.zystkstshjg === 1">未通过</span>
                    <span v-if="scope.row.zystkstshjg === 0">未审核</span>
                  </template>
                </el-table-column>
                <!-- 冻结列-Left END -->
                <!-- 冻结列-Right BEGIN -->
                <el-table-column label="操作" width="200" fixed="right" align="center">
                  <template #default="scope">
                    <el-button link type="primary" v-if="scope.row.zystkstshtjzt===false || scope.row.zystkstshjg === 1" @click="dataGrid.multipleSelection=[scope.row.id]; tiJiaoClick()">提交</el-button>
                    <el-button link type="success" @click="openTableDetail=true;row=scope.row">详情</el-button>
                    <el-button link type="primary" v-if="scope.row.zystkstshtjzt===false || scope.row.zystkstshjg === 1" @click="openTableEdit=true;row=scope.row">修改</el-button>
                    <el-button link type="warning" v-if="scope.row.zystkstshtjzt===false || scope.row.zystkstshjg === 1" @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
                  </template>
                </el-table-column>
                <!-- 冻结列-Right END -->
              </el-table>
            </el-main>
            <el-footer class="pl0 pr0">
              <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable()" />
            </el-footer>
          </el-container>
        </el-main>
        <!-- 试题区域 END -->
      </el-container>
      <!-- <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button @click="openList=false;homeCloseWindow('openReturn', emits, false)">关闭</el-button>
          </div>
        </div>
      </template> -->
    </el-dialog>
  </div>
  <!-- 试题库 END -->
  <!-- 试题 BEGIN -->
  <tableAdd v-if="openTableAdd" v-model:openAdd="openTableAdd" :row="row" @ReturnData="bindTree();bindTable()" />
  <tableEdit v-if="openTableEdit" v-model:openEdit="openTableEdit" :row="row" @ReturnData="bindTree();bindTable()" />
  <tableDetail v-if="openTableDetail" v-model:openDetail="openTableDetail" :row="row" />
  <!-- 试题 END -->

</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { actionPost, loadList, loadSelect, homeCloseWindow,
  submitExcel,
  exportExcel,
  downloadTemplate
} from '@/api/common.js'
import { loadZiDianSelect } from '@/api/queryZiDian.js'
import { ElMessageBox } from 'element-plus'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import tableAdd from '@/pages/shuzijiaoxue/ziyuanku/shitiku/shiti/add.vue'
import tableEdit from '@/pages/shuzijiaoxue/ziyuanku/shitiku/shiti/edit.vue'
import tableDetail from '@/pages/shuzijiaoxue/ziyuanku/shitiku/shiti/detail.vue'

import pagination from '@/components/pagination.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const txData = ref() // 题型
const tlData = ref() // 题类
const kcData = ref() // 课程
// 弹窗
const row = ref()
const openTableAdd = ref(false)
const openTableEdit = ref(false)
const openTableDetail = ref(false)
const openList = ref(false)

const zyData = ref()
loadSelect({
  url: '/api/v2/pdp/zhuanye/list',
  data: zyData,
  order: 'zybh',
  sort: 'asc'
})
// 试题库 BEGIN
const treeData = ref()
const treeDataGrid = ref({ parms: {}, multipleSelection: [], loading: false })
const bindTree = async () => {
  treeDataGrid.value.loading = true
  loadSelect({
    url: '/api/v2/ziyuanku/zhuanyeku/dangqianjiaoshishitikulist',
    data: treeData,
    // order: 'stkmc',
    // sort: 'asc',
    loadSuccess: function (res) {
      treeDataGrid.value.loading = false
      treeDataGrid.value.multipleSelection = []
    }
  })
}
// 试题库 END
// 试题 BEGIN
// 提交
const tiJiaoClick = (item) => {
  const o = { url: '/api/v2/ziyuanku/zhuanyeku/zhuanyeshiti/shitishenhetijiao', data: { id: dataGrid.value.multipleSelection } }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      bindTable()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
const remove = async () => {
  if (dataGrid.value.multipleSelection.length === 0) {
    warningPrompt('至少选择一行')
    return
  }
  ElMessageBox.confirm('确定要删除吗?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    dataGrid.value.loading = true
    const options = { url: '/api/v2/ziyuanku/zhuanyeku/zhuanyeshiti/shouyedelete', data: { ids: dataGrid.value.multipleSelection } }
    actionPost(options).then((res) => {
      dataGrid.value.loading = false
      if (res.code === 200) {
        bindTable()
        successPrompt(res.message)
      } else {
        return ElMessageBox.confirm(res.message, '警告',
          {
            showCancelButton: false,
            confirmButtonText: '关闭',
            type: 'warning'
          }
        )
      }
    })
  })
}
const addShiTiClick = () => {
  if (!dataGrid.value.parms.zystkstkid) {
    return warningPrompt('请选择试题库')
  }
  openTableAdd.value = true
}
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'zystkstscsj', order: 'descending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bind()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/ziyuanku/zhuanyeku/zhuanyeshiti/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}
// 试题 END
watch(
  () => props.open,
  () => {
    if (props.open === 'shitiku') {
      openList.value = true
      loadZiDianSelect('题型', txData)
      loadZiDianSelect('题类', tlData)
      loadSelect({ url: '/api/v2/jiaowu/kecheng/list', data: kcData, order: 'kch', sort: 'asc' })
      bindTree()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
// Excel导入数据
const importInsert = async (file) => {
  submitExcel({
    url: '/api/v2/ziyuanku/shiti/importInsert',
    file: file,
    callback: function () {
      bindTable()
    }
  })
}
// Excel导出
const exportData = async () => {
  exportExcel('/api/v2/ziyuanku/shiti/export', dataGrid.value)
}

// 模板下载
const download = async () => {
  downloadTemplate('/api/v2/ziyuanku/shiti/download')
}
</script>

<style lang="less" scoped>
:deep(.el-tree-node__content) {
  width: 100%;
}
:deep(.el-tree-node__label) {
  width: 100%;
}
:deep(.custom-tree-node) {
    width: 100%;
    display: flex;
    justify-content: space-between;
}
</style>
